import React from 'react'
import { NumericFormat } from 'react-number-format'
import { StyledTextField } from '../TextField/styles'

export function NumberField(props) {
  const { name, onChange, ...otherProps } = props

  const handleChange = ({ value }) => {
    onChange({ target: { name, value } })
  }

  return (
    <NumericFormat
      name={name}
      thousandSeparator="."
      decimalSeparator=","
      fixedDecimalScale={false}
      customInput={StyledTextField}
      isNumericString={true}
      onValueChange={handleChange}
      variant="outlined"
      size="small"
      {...otherProps}
    />
  )
}
